/**
 * Sysadmin Catalog → Agent Detail — REDIRECT to builder.
 *
 * UI PARITY (PR phase4/sysadmin-agent-builder-port, 2026-05-11):
 *
 * The previous 2,184-LOC 9-tab schema-first record viewer at this
 * route diverged sharply from the canonical tenant builder
 * (`routes/agents/builder.tsx`, 1,122 LOC). The parity audit
 * (tasks/ae66d459e3174818a.output §6) flagged this as a violation of
 * the founder's UI parity rule:
 *
 *   "When same entity exists at both sysadmin and tenant scope, the
 *    UI must be IDENTICAL. Copy-paste from canonical tenant UI; don't
 *    reinvent."
 *
 * The full agent view + edit + lifecycle flow now lives at
 * `/sysadmin/catalog/agents/builder?id=<agentId>`. This route is
 * preserved only as a redirect so existing bookmarks + table links
 * continue to work without 404s.
 *
 * If you need to look at the deleted shell, it's in git history at
 * commit `d8a71899` (master pre-port).
 */

import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/agents/$id')({
  component: SysadminCatalogAgentDetailRedirect,
});

function SysadminCatalogAgentDetailRedirect() {
  const { id } = Route.useParams();
  return (
    <Navigate
      to="/sysadmin/catalog/agents/builder"
      search={{ id, model: undefined }}
      replace
    />
  );
}
